/**
 * Lit Web Components Entry Point
 *
 * Import this file to register all Lit web components.
 * These components can be used in:
 * - AngularJS templates
 * - Angular templates (with CUSTOM_ELEMENTS_SCHEMA)
 * - Plain HTML
 *
 * Web components are framework-agnostic and provide a migration path
 * that doesn't lock us into any specific framework.
 */

// Components
export * from './components/example-card/example-card';
export * from './components/tailwind-card/tailwind-card';

// Log registration
console.log('[Lit] Web components registered');

